export let EmailRecipient;
(function (_EmailRecipient) {
  let Problem = /*#__PURE__*/function (Problem) {
    Problem["BOUNCED"] = "bounced";
    Problem["UNSUBSCRIBED"] = "unsubscribed";
    Problem["UNSUBSCRIBED_FROM_ALL_COMMUNICATIONS"] = "unsubscribed_from_all_communications";
    Problem["DUPLICATE"] = "duplicate";
    return Problem;
  }({});
  _EmailRecipient.Problem = Problem;
  let EmailAddressStatus = /*#__PURE__*/function (EmailAddressStatus) {
    EmailAddressStatus["OK"] = "ok";
    EmailAddressStatus["BOUNCED"] = "bounced";
    EmailAddressStatus["UNSUBSCRIBED"] = "unsubscribed";
    EmailAddressStatus["UNSUBSCRIBED_FROM_ALL_COMMUNICATIONS"] = "unsubscribed_from_all_communications";
    return EmailAddressStatus;
  }({});
  _EmailRecipient.EmailAddressStatus = EmailAddressStatus;
})(EmailRecipient || (EmailRecipient = {}));